import {Skeleton} from 'src/components/skeleton'
import {useNavigationMenu} from 'src/layouts/main-layout/app-sidebar/navigation/hooks/use-navigation-menu.hook'
import {AppSidebarNavItem} from './app-sidebar-nav-item'

export function AppSidebarNav() {
  const {data: menu, isLoading} = useNavigationMenu()

  if (isLoading) {
    return (
      <nav data-slot='sidebar-nav' className='flex flex-col gap-3'>
        {Array.from({length: 5}).map((_, i) => (
          <Skeleton key={i} className='h-10 w-full' />
        ))}
      </nav>
    )
  }

  return (
    <nav data-slot='sidebar-nav' className='flex flex-col gap-1'>
      {menu?.map((navigationMenu) => <AppSidebarNavItem key={navigationMenu.id} navigationMenu={navigationMenu} />)}
    </nav>
  )
}
